<template>
      <a-button :style="style" danger @click="handleOpen">
        {{  this.btnText ? this.btnText : '运行' }}
      </a-button>
      <a-modal
        :title="batchBy ? '批量运行' : '运行参数'"
        v-model:visible="openDia" 
        @cancel="resetForm" 
        @ok="handleConfirm" 
        :confirm-loading="loading"
        width="900px"
      >
        <a-form :model="formRecord" :label-col="{span: 5}" >
          <a-form-item required label="任务说明" name="remark">
            <a-input  v-model:value="formRecord.remark" />
          </a-form-item>
           <hr />
           <a-form-item  v-if="!formRecord.custom_prompt" label="Prompt 素材包">
             <a-select
              show-search
              :allowClear="true"
              v-model:value="formRecord.prompt_package_id"
              :options="promptPackagesOptions"
              placeholder="Prompt"
            />
          </a-form-item>
         
          <a-form-item label="自定义 Prompt" name="custom_prompt">
            <a-textarea placeholder="自定义 Prompt（最优先使用）" v-model:value="formRecord.custom_prompt" />
          </a-form-item>
           <a-form-item  label="ReferImage 素材包">
             <a-select
              show-search
              :allowClear="true"
              v-model:value="formRecord.refer_image_package_id"
              :options="referImagePackagesOptions"
              placeholder="refer_image"
            />
          </a-form-item>
            <a-form-item label="扩展参数" name="extra_params">
            <a-textarea placeholder="高级功能，谨慎使用" v-model:value="formRecord.extra_params" />
          </a-form-item>
           <hr />
           <a-form-item  label="指定本次任务类型" >
            <a-select
                    show-search
                    option-filter-prop="label"
                    v-model:value="formRecord.style_id"
                  :options="TaskStyleGroupOptions"
                />
                <p style="color:red;margin-top:5px;">*API 类型任务必选 </p>
           </a-form-item>
         
           <hr />
          <a-form-item  label="筛选Topic">
             <a-select
              show-search
              :allowClear="true"
              v-model:value="formRecord.topic"
              @search="handleSearchTopics"
              :options="searchTopics"
              @change="handleTopicChange"
              placeholder="Topic"
            />
          </a-form-item>
        
          <a-form-item  label="远端地址(自定义)" >
            <a-input  v-model:value="formRecord.remote_url" />
            
          </a-form-item>
          <a-collapse v-if="executors.length > 0" style="margin-top:10px;" v-model:activeKey="remoteExecutorsShowup">
              <a-collapse-panel key="1" header="XAE 地址列表(多选)">
                <div>
                <!-- <p>远端地址</p> -->
                <a-row>
                  <a-col :span="3">
                    主机名
                  </a-col>
                  <a-col :span="13">
                    地址
                  </a-col>
                  <a-col :span="2">
                    GPU
                  </a-col>
                  <a-col :span="2">
                    状态
                  </a-col>
                  <a-col :span="4">
                    操作
                  </a-col>
                </a-row>
                <a-row  v-for="executor in executors"  :key="executor.executor_id" style="height:30px; margin: 8px;">
                  <a-col :span="3">
                    <div :style="{'width': '8px', 'height': '8px', 'border-radius': '50%', 'background': toColor(executor.host_name),'display': 'inline-block'}" style=""></div>
                    {{ executor.host_name }}
                  </a-col>
                  <a-col :span="13">
                    {{ executor.remote_url }}
                  </a-col>
                  <a-col :span="2">
                    {{ executor.target_gpu_port }}
                  </a-col>
                  <a-col :span="2">
                    <a-tag v-if="executor.running_status == 'running'" color="grey"> online </a-tag>
                    <a-tag v-else-if="executor.case_task_id" color="red">process</a-tag>
                    <a-tag v-else color="green"> ready</a-tag>

                  </a-col>
                  <a-col :span="4">
                    <a-button size="small" v-if="!executor.selected" :disabled="executor.running_status == 'running' || !!executor.case_task_id" @click="() => handleSelectExecutor(executor)" danger>
                      选择 <span v-if="executor.last_selected" > (last)</span>
                    </a-button>
                    <div v-if="executor.selected" style="display: flex; align-items: center;" >
                      <a-button size="small" v-if="executor.selected" style="margin: 4px;" @click="() => handleSelectExecutor(executor)" type="primary" danger >已选 ✖️</a-button>
                    </div>

                  </a-col>
                </a-row>
              </div>
              </a-collapse-panel>
            </a-collapse>
          <a-form-item required  label="运行次数" >
            <a-input type="number" v-model:value="formRecord.run_count" />
          </a-form-item>
        </a-form>
       

      <div style="margin: 10px;">
        <h2>简述</h2>
        <p v-if="caseIDs.length > 0">已选择 <a-tag>{{  caseIDs.length }}</a-tag> 个 case</p>
        <p v-if="formRecord.case_id > 0">运行 case_id: <a-tag>{{  formRecord.case_id }}</a-tag></p>
        <p>算法测试平台将这个 case 运行 <a-tag>{{ formRecord.run_count }}</a-tag> 次</p>
        <p v-if="formRecord.custom_prompt">已使用自定义 Prompt: <span style="background: #EEE;">{{ formRecord.custom_prompt }}</span></p>
        <p v-if="formRecord.remote_url != ''">使用自定义远端地址: <a-tag>{{ formRecord.remote_url }}</a-tag></p>
        <p v-if="formRecord.remote_url == '' && xaeSelectedCount>0">已选择 {{ xaeSelectedCount }} 个 XAE 地址，会创建 {{ xaeSelectedCount }} 个批量任务</p>
        <p v-if="formRecord.prompt_package_id">已选择 Prompt 素材包 「{{ promptPackages[formRecord.prompt_package_id].name }}」, 包含 {{ promptPackages[formRecord.prompt_package_id].resource_count }} 个 Prompt</p>
        <p v-if="formRecord.refer_image_package_id">已选择 ReferImage 素材包 「{{ referImagePackages[formRecord.refer_image_package_id].name }}」, 包含 {{ referImagePackages[formRecord.refer_image_package_id].resource_count }} 个 ReferImage</p>
      </div>
    </a-modal>

   
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  // import {CheckCircleOutlined,CloseCircleOutlined} from '@ant-design/icons-vue';
  import { TaskStyleGroupOptions, SubTypeOptions ,StyleNames, ToolIDOptions, ExecutorTopics} from '@/utils/macro'

  const FormRecord = {
    case_id: 0,
    remark: '',
    topic: '',
    remote_url: '',
    run_count: 1,
    custom_prompt: '',
    style_id: '',
    prompt_package_id: '',
    refer_image_package_id: '',
    extra_params: '',
  }

  var topicSelection = []
for (var i = 0; i < ExecutorTopics.length; i++) {
  topicSelection.push({
    value: ExecutorTopics[i].topic,
    label: ExecutorTopics[i].name + "(" + ExecutorTopics[i].topic + ")",
  })
}

const StyleIDToTopic = {
  '13': "aitools.clothes",
  '0': "aitools.replace",
  '1': "aitools.add",
  '2': "aitools.remove",
  '4': "aitools.replace_background",
  '22': "aitools.faceswap",
  '81': "aitools.multiangle",
  'qwen_bt_breast_v2': "aitools.qwen_bt_breast_v2",
}
const StyleIDToTopicPaths = {
  "aitools.clothes": [
    "replace_clothes_with_reference",
     "replace_clothes_with_prompt",
  ],
  "aitools.replace": [
    "replace_all",
  ],
  "aitools.add": [
    "replace_all",
  ],
  "aitools.remove": [
    "upload_img_remove",
  ],
  "aitools.replace_background": [
    "replace_background",
  ],
  "aitools.replacebg.reference": [
    "replace_background_with_reference",
  ],
  "aitools.replacebg.prompt": [
    "replace_background_with_prompt",
  ],
  "aitools.faceswap": [
    "faceswap",
  ],
  "aitools.multiangle": [
    "qwen_multi_angle",
  ],
  "aitools.shouyao": [
    "qwen_bt_shouyao",
  ],
  "aitools.qwen_bt_breast_v2": [
    "qwen_bt_breast_v2",
  ],
}

export default defineComponent({
  emits: ['ok'],
  props: ['case', 'style', 'btnText', 'batchBy'],
  // components:{CheckCircleOutlined,CloseCircleOutlined},
  data(){
    return {
      TaskStyleGroupOptions,
      remoteExecutorsShowup: "0",
      loading: false,
      openDia: false,
      StyleNames,
      remoteUrls: [],
      searchTopics: [].concat(topicSelection),
      executors:[],
      promptPackages:{},
      promptPackagesOptions:[],
      referImagePackages: {},
      referImagePackagesOptions:[],
      formRecord: {
        ...FormRecord,
      },
      caseIDs: [],
      // imageUrl: '',
    }
  },
  watch: {
    openDia: {
      handler(newVal, oldVal) {
        if (newVal == true) {
          this.formRecord.topic = StyleIDToTopic[this.case.style_id]
          this.handleTopicChange()
          this.handleSearchTopics()
        }
      }
    }
  },
  computed: {
    xaeSelectedCount(){
      return this.executors.filter((v) => v.selected).length
    }
  },
  mounted() {
   
    // this.imageUrl = this.modelValue
  },
  methods: {
    // handelCustomPrompt(){

    // },
    handleOpen: function() {
      console.log("this.case", JSON.parse(JSON.stringify(this.case)))
      this.openDia = true
      this.formRecord = {
        ...FormRecord,
        case_id: `${this.case.id}`,
      }
      if (this.batchBy) {
        if (this.formRecord.style_id == "" && this.batchBy.style_id) {
          this.formRecord.style_id =  this.batchBy.style_id
        }
        if (this.batchBy.ids && this.batchBy.ids.length > 0) {
          this.caseIDs = this.batchBy.ids
        }
        if (this.batchBy.batch_id > 0) {
          request.get(`/api/testcase/batches/${this.batchBy.batch_id}`).then((rsp) => {
            if (rsp.code == 0) {
              this.formRecord.remark = rsp.data.item.batch_name
              this.formRecord.tool_id = rsp.data.item.tool_id
              this.formRecord.style_id = rsp.data.item.style_id
              this.formRecord.remote_url = rsp.data.item.remote_url
            }
          })
          // 需要获取一下 cases
          request.get(`/api/testcase/batches/${this.batchBy.batch_id}/cases`).then((rsp) => {
            if (rsp.code == 0) {
              // console.log(rsp)
              this.caseIDs = rsp.data.items.map((v) => v.id)
            }
          })
        }
      }

      let lastRemoteURL = window.sessionStorage.getItem("lastRemoteURL")
      if (lastRemoteURL) {
        this.formRecord.remote_url = lastRemoteURL
      }
      this.getPromptPackages()
      this.getReferImagePackages()
    },
    getReferImagePackages(){
      request.get(`/api/testcase/packages/`,{
        resource_type: "refer_image",
      }).then((rsp) => {
        if (rsp.code == 0) {
          this.referImagePackagesOptions = []
          for (let v of rsp.data.list) {
            this.referImagePackages[v.id] = v
            this.referImagePackagesOptions.push({
              ...v,
              label: v.name + "(" + v.resource_count + ")",
              value: `${v.id}`,
            })
          }
        }
      })
    },
    getPromptPackages(){
      request.get(`/api/testcase/packages/`,{
        resource_type: "prompt",
      }).then((rsp) => {
        if (rsp.code == 0) {
          this.promptPackagesOptions = []
          for (let v of rsp.data.list) {
            this.promptPackages[v.id] = v
            this.promptPackagesOptions.push({
              ...v,
              label: v.name + "(" + v.resource_count + ")",
              value: `${v.id}`,
            })
          }
        }
      })
    },
    handleSearchTopics(val){
      if (!val) {
        this.searchTopics = topicSelection
        return
      }
      this.searchTopics = []
      for (let v of topicSelection) {
        if(v.label.indexOf(val) > -1) {
          this.searchTopics.push({
            ...v
          })
        }
      }
      console.log("this.searchTopics", this.searchTopics)
    },
    resetForm() {
      this.formRecord = {
        ...FormRecord,
      }
      this.executors = []
      this.remoteExecutorsShowup = "0"
      this.remoteUrls = []

    },
    handleSelectExecutor(executor){
      // target_host: http://222.186.161.109/api/
      if (executor.selected) {
        executor.selected = false
      } else {
        executor.selected = true
      }
      window.sessionStorage.setItem("selectedExecutor", executor.remote_url)
    },
    
    async handleConfirm(){
      if (this.formRecord.prompt_package_id && this.formRecord.refer_image_package_id) {
        message.error("只支持选择一个素材包")
        return 
      }
      console.log("formRecord", JSON.parse(JSON.stringify(this.formRecord)))
      this.remoteUrls = []
      for (let executor of this.executors) {
        if (executor.selected) {
          this.remoteUrls.push(executor.remote_url)
        }
      }
      console.log("this.this.formRecord", JSON.parse(JSON.stringify(this.formRecord)))
      this.formRecord.remote_url = this.formRecord.remote_url.trim()
      if (this.formRecord.remote_url != '' && this.remoteUrls.length > 0) {
        message.error("自定义和选择执行器不能同时使用")
        return 
      }
      if (this.formRecord.remote_url != '') {
        window.sessionStorage.setItem("lastRemoteURL", this.formRecord.remote_url )
        this.remoteUrls.push(this.formRecord.remote_url)
      } 

      if (this.batchBy && this.formRecord.remark == '') {
        message.error("请输入任务说明")
        return 
      }

  
      if (this.formRecord.style_id == "" && this.remoteUrls.length == 0) {
        message.error("请选择任务类型或输入 RemoteURL或选择 XAE 实例")
        return 
      }
      // 部分任务（API类型）选择了 style_id 即可
      if (this.formRecord.style_id != "" &&  this.remoteUrls.length == 0) {
        this.remoteUrls = [""]
      }
      if (this.remoteUrls.length == 0) {
        message.error("请选择执行器或输入远程URL")
        return 
      }
      
      this.loading = true

      if (this.remoteUrls.length > 0) {
        for (let remoteUrl of this.remoteUrls) {
          // 暂停 200ms
          await new Promise(resolve => setTimeout(resolve, 200));
          let batchBy = this.batchBy || {}
          if (this.batchBy) {
            batchBy = {
              ...batchBy,
            }
          }
          if (this.caseIDs && this.caseIDs.length > 0) {
            batchBy = {
              ...batchBy,
              ids: this.caseIDs,
            }
          }
          batchBy.labels = Array.isArray(batchBy.labels) ? batchBy.labels.join(',') : batchBy.labels
          let input = {
            ...this.formRecord,
            run_count: +this.formRecord.run_count,
            remote_url: remoteUrl,
            batch_by: batchBy,
          }
          // console.log(JSON.parse(JSON.stringify(input)))
          // return
          request.post(`/api/testcase/cases/run`, input, null).then((rsp) => {
            if (rsp.code == 0) {
              message.success('用例运行成功，请等待执行完毕')
              if (rsp.data && rsp.data.batch_id) {
                 this.$router.push({
                  path: '/home/testcase/tasks',
                  query: {
                    batch_id: rsp.data.batch_id,
                  }
                })
              } 
              // else if (this.formRecord.case_id) {
              //    this.$router.push({
              //     path: '/home/testcase/tasks',
              //     query: {
              //       case_id: this.formRecord.case_id,
              //     }
              //   })
              // }
            } else {
              message.error(rsp.msg)
            }
          }).catch((err) => {
            message.error(err.message)
          })
        }
      }
      this.loading = false
      this.openDia = false
      this.resetForm()
      this.$emit('ok')
      
    },
    handleTopicChange(){
      if (!this.formRecord.topic) {
        return
      }
      this.loading = true
      let lastSelect = window.sessionStorage.getItem("selectedExecutor")
      if (!StyleIDToTopicPaths[this.formRecord.topic]) {
        message.error('当前 Topic 暂不支持筛选，可手动输入 RemoteURL ')
        this.loading = false
        return
      }
      request.get('/api/testcase/cases/remotes', {
        offset: 0,
        limit: 200,
        topic: this.formRecord.topic,
      }).then((rsp) => {
        if (rsp.code == 0) {
          var executors = rsp.data.list
          for (let k in rsp.data.list) {
            executors[k].selected = false
          }
          for (let remotePath of StyleIDToTopicPaths[this.formRecord.topic]) {
            for (let executor of executors) {
              let remoteUrl = executor.target_host.replace("/api/", ":" + executor.target_gpu_port) + `/${remotePath}`
              this.executors.push({
                ...executor,
                remote_url: remoteUrl,
                last_selected: remoteUrl == lastSelect,
              })
            }
          }
          // this.remoteExecutorsShowup = "1"
        } else {
          message.error(rsp.msg)
        }
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
      this.loading = false
    },
    toColor: function(str) { 
      let hash = 0; 
      for (let i = 0; i < str.length; i++) { 
          hash = str.charCodeAt(i) + ((hash << 5) - hash); 
      } 
      let color = '#'; 
      for (let i = 0; i < 3; i++){ 
        const value = (hash >> (i * 8)) & 0xFF; 
        color += ('FF' + value.toString(16)).substr(-2); 
      } 
      return color; 
    },
  },
})
</script>
<style lang='scss' scoped>

</style>
